import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=c53db538&scoped=true"
import script from "./editUser.vue?vue&type=script&lang=js"
export * from "./editUser.vue?vue&type=script&lang=js"
import style0 from "./editUser.vue?vue&type=style&index=0&id=c53db538&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53db538",
  null
  
)

export default component.exports